/**
 * One external-regime code mapped to an Idwal defect code.
 *
 * Shape comes from the defect service's `mappings.json`
 * (`GET /defects/regime/{type}` on the internal API), produced from the Data
 * team's mapping workbook. `regime` is the harmonised MoU name — `MoU` when
 * Paris and Tokyo agree on a code, `PMoU`/`TMoU` when only one carries it.
 */
export type RegimeMapping = {
    regime: string;
    code: string;
    /** Presentation rank from the workbook; 1 shows first. */
    order: number;
};

/** `mappings.json`: Idwal defect code -> the regime codes it maps to. */
export type RegimeMappings = Record<string, RegimeMapping[]>;

/** The regime family in the endpoint path, allow-listed server side. */
export const PSC_REGIME_TYPE = "psc";
